import { ErrorMessage } from '@hookform/error-message';
import { ITimezone, useGetTimeZonesQuery } from 'app/services/constants';
import ErrorMessageStyle from 'Components/Form/ErrorMessageStyle';
import Label from 'Components/Form/Label';
import SelectSearchDropDown from 'Components/Form/SearchDropDown/SelectSearchDropDown';
import { Controller, useFormContext } from 'react-hook-form';
import { useTimezones } from 'utils/ConstantsProvider';

export default function TimezoneSelector({
  name = 'time_zone_id',
  label = 'Timezone',
}: {
  name?: string;
  label?: string;
}) {
  const form = useFormContext();

  const timezones = useTimezones();

  return (
    <Controller
      render={({ field }) => (
        <Label label={label}>
          <SelectSearchDropDown
            valueId={field.value}
            onChangeId={field.onChange}
            options={timezones || []}
            optionItemSkin={(tz, isActive) => (
              <div>
                <div className={isActive ? 'text-white' : 'text-gray-dark'}>
                  {tz.abbr} - {tz.value}
                </div>
                <div
                  className={
                    isActive ? 'text-white text-xs' : 'text-gray-700 text-xs'
                  }
                >
                  {tz.text}
                </div>
              </div>
            )}
            selectedItemSkin={(tz) => `${tz.abbr} - ${tz.value}`}
            searchFilter={(needle, options) =>
              options.filter(
                (o) =>
                  o.text.toLowerCase().includes(needle.toLowerCase()) ||
                  o.value.toLowerCase().includes(needle.toLowerCase()) ||
                  o.abbr.toLowerCase().includes(needle.toLowerCase()),
              )
            }
          />
          <ErrorMessage
            errors={form.formState.errors}
            name={name}
            render={({ message }) => <ErrorMessageStyle message={message} />}
          />
        </Label>
      )}
      control={form.control}
      name={name}
    />
  );
}
